import React, { Component } from "react"

class CardDefault extends Component {

    render() {
        const { label, value, subText, icon, colorBall, colorIcon } = this.props

        return(
            <div className="container-default d-flex justify-content-between" style={{width: "calc(100% / 4)"}}>
                <div className="d-flex flex-column">
                    <span style={{color: "#979797", fontWeight: "bold"}}>{label}</span>
                    <span style={{color: "black", fontSize: "20px", fontWeight: "bold"}}>{value}</span>
                    <span style={{color: "#979797"}}>{subText}</span>
                </div>
                <div>
                    <div className="d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", borderRadius: "30px", backgroundColor: colorBall }}>
                        <i className={icon} style={{color: colorIcon}}></i>
                    </div>
                </div>
            </div>
        )
    }
}

export default CardDefault